import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useState } from 'react';
import { ICandidate, INotes, IUserDTO, updateCandidateSubmission } from 'wisestep-api';
import { useWsEditor, WsButton, WsDialog, WsEditor } from 'wisestep-base';

import { useUserContext } from '../../../../../context';
import { getRecruiterFullName } from '../../../../../features/candidateLayout/utils/CandidateHelper';
import { success, warning } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';

interface AddNoteDialogProps {
  openDialog: boolean;
  submission: ICandidate;
  handleCloseDialog: () => void;
}

const AddNoteDialog = ({ openDialog, handleCloseDialog, submission }: AddNoteDialogProps) => {
  const [note, setNote] = useState<string>('');
  const setNotification = useNotificationStore((state) => state.setNotification);
  const editor = useWsEditor(note, (htmlBody) => {
    setNote(htmlBody ?? '');
  });
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  const loggedInUserName = getRecruiterFullName(loggedInUser);
  const updateCandidateNoteSubmission = async () => {
    const notes = {
      notes: note,
      createdAt: '',
      createdBy: loggedInUserName ?? '',
      recruiterId: loggedInUser?.email ?? '',
    } as INotes;
    try {
      await updateCandidateSubmission([{ ...submission, candidateNotes: [notes] }]);
      handleCloseNotesDialog();
      setNotification(success('Submission updated successfully'));
      window.location.reload();
    } catch (e) {
      console.error('Error occured while updating the submission ', e);
      setNotification(warning('Error occured while updating submission'));
    }
  };
  const handleCloseNotesDialog = () => {
    editor?.commands?.setContent('');
    setNote('');
    handleCloseDialog();
  };
  return (
    <>
      <WsDialog openDialog={openDialog} onClose={handleCloseNotesDialog} size="medium">
        <DialogTitle>Add Notes</DialogTitle>
        <DialogContent>
          <WsEditor editor={editor} toolbar resizable editorHeight={300} disable={false} />
        </DialogContent>
        <DialogActions>
          <WsButton onClick={handleCloseNotesDialog}>Cancel</WsButton>
          <WsButton variant="contained" onClick={updateCandidateNoteSubmission}>
            Save
          </WsButton>
        </DialogActions>
      </WsDialog>
    </>
  );
};

export default AddNoteDialog;
